import { useDebounceCallback } from '@react-hook/debounce';
import useQueryParams from 'components/hooks/useQueryParams';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { allContributorsTeamSelector } from 'state/selectors/teams';
import { selectedTeamSelector } from 'state/selectors/ui-state';

const useSelectAllContributors = () => {
  const { updateQueryParam } = useQueryParams();

  const selectedTeam = useSelector(selectedTeamSelector);
  const allContributorsTeam = useSelector(allContributorsTeamSelector);

  const updateAllContributorsFiltersQs = useDebounceCallback(() => {
    const isAllControbutorsTeamSelected =
      allContributorsTeam?.id === selectedTeam?.id;

    if (isAllControbutorsTeamSelected) {
      updateQueryParam('connected_branches', null);
    } else {
      updateQueryParam('connected_branches', 'true');
    }
  }, 100);

  useEffect(() => {
    updateAllContributorsFiltersQs();
  }, [selectedTeam]);
};

export default useSelectAllContributors;
